// src/pages/admin/bookings/components/BookingDates.tsx

import * as React from "react";
import { Stack, Typography, Chip } from "@mui/material";
import { fmtDateRange, nightsBetween } from "../bookingTypes";

export default function BookingDates({
    checkIn,
    checkOut,
    showNights = true,
}: {
    checkIn?: string | null;
    checkOut?: string | null;
    showNights?: boolean;
}) {
    const nights = nightsBetween(checkIn, checkOut);
    return (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
                {fmtDateRange(checkIn, checkOut)}
            </Typography>
            {showNights && nights !== null && nights >= 0 && (
                <Chip
                    size="small"
                    label={`${nights} night${nights === 1 ? "" : "s"}`}
                    variant="outlined"
                    sx={{ borderRadius: 999, fontWeight: 700 }}
                />
            )}
        </Stack>
    );
}
